import { ZONE_CARDS } from './wizardConstants'

/**
 * Proposer un produit, ecran 2 : « Dans quel rayon le classer ? »
 * (prototype v7.4, WizardOffre/prop.rayon) — une liste A PLAT de boutons de
 * verre, un par rayon ; toucher un rayon le choisit ET avance. Plus de
 * drill-down zone → sous-categorie (S71, retour Enzo : « pas comme le
 * prototype »). Nos categories sont plus nombreuses que les rayons du
 * prototype : la zone reste, en simple intertitre, pour s'y retrouver.
 */
function StepProposeCategory({ categories, categoryId, onSelect }) {
  const groupes = ZONE_CARDS
    .map((z) => ({ ...z, cats: (categories || []).filter((c) => z.zones.includes(c.zone)) }))
    .filter((g) => g.cats.length > 0)
  const orphelines = (categories || []).filter((c) => !ZONE_CARDS.some((z) => z.zones.includes(c.zone)))
  if (orphelines.length) groupes.push({ key: 'sans-zone', label: 'Autres', cats: orphelines })

  if (groupes.length === 0) {
    return <p className="text-[13px] text-ink/60">Aucun rayon disponible pour le moment.</p>
  }

  return (
    <div className="flex flex-col gap-2">
      {groupes.map((g) => (
        <div key={g.key} className="flex flex-col gap-2">
          {groupes.length > 1 && (
            <p className="text-[10.5px] font-bold uppercase mt-1.5" style={{ letterSpacing: 1.5, color: 'rgb(var(--c-teal))' }}>
              {g.label}
            </p>
          )}
          {g.cats.map((cat) => {
            const actif = cat.id === categoryId
            return (
              <button
                key={cat.id}
                onClick={() => onSelect(cat)}
                className="panneau-verre rounded-2xl px-[15px] py-[13px] text-sm font-bold text-ink text-left flex items-center gap-2.5"
                style={{ border: actif ? '1.5px solid rgb(var(--c-primary))' : '1px solid rgba(7,62,61,0.08)' }}
              >
                <span className="text-lg leading-none">{cat.emoji || '📦'}</span>
                <span className="flex-1 min-w-0 truncate">{cat.nom}</span>
              </button>
            )
          })}
        </div>
      ))}
    </div>
  )
}

export default StepProposeCategory
